import { TXTWCL_Must_be_shorter_than_N0_charac_ELL } from '../translations';
import type { Error } from '../types';

export const maxLength =
  (
    max: number,
    message: Error['message'] = {
      ...TXTWCL_Must_be_shorter_than_N0_charac_ELL,
      values: { 0: max + 1 }
    },
    allowEmpty = false
  ) =>
  (value: string): Error => {
    const valid = value?.length <= max;

    return {
      valid: allowEmpty ? !value || valid : valid,
      message
    };
  };
